'use strict';

module.exports = {
    SHARE: 'Share',
    SEND: 'Send',
    SUBMIT: 'Submit'
};